var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "sc-field",
        { attrs: { grouped: "", position: "is-right" } },
        [
          _c(
            "sc-select",
            {
              attrs: { placeholder: "Alterar status" },
              on: { input: _vm.changeState }
            },
            [
              _c("option", { attrs: { value: "APPROVED" } }, [
                _vm._v("Aprovado")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "PAID" } }, [_vm._v("Pago")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "ANALYZED" } }, [
                _vm._v("Analisado")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "sc-table",
        {
          staticClass: "tab-history",
          attrs: {
            data: _vm.invoiceHistory,
            loading: _vm.loadingInvoiceHistory
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(props) {
                return [
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "invoice_state",
                        label: "Status",
                        centered: false,
                        sortable: ""
                      }
                    },
                    [
                      _c("sc-invoice-audit-tag-status", {
                        attrs: { status: props.row.invoice_state }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: { field: "created", label: "Data", sortable: "" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("date")(
                              props.row.created,
                              "DD/MM/YYYY HH:mm"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "description",
                        label: "Descrição",
                        centered: false,
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.description) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { field: "attachment_url", label: "Anexo" } },
                    [
                      props.row.attachment_url
                        ? _c(
                            "button",
                            {
                              staticClass: "button is-primary is-small",
                              on: {
                                click: function($event) {
                                  _vm.downloadInvoiceFilePerUrl(
                                    props.row.attachment_url
                                  )
                                }
                              }
                            },
                            [
                              _c("sc-icon", {
                                attrs: {
                                  icon: "cloud-download-alt",
                                  size: "is-small"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Baixar")])
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "user_name",
                        label: "Usuário",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(props.row.user_name) + "\n      "
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _c(
            "template",
            { attrs: { slot: "empty" }, slot: "empty" },
            [_c("sc-table-empty")],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b15f3d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b15f3d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/pages/invoice-audit-detail/components/tab-history/TabInvoiceAuditDetailHistory.vue
// module id = null
// module chunks = 